import { render, staticRenderFns } from "./lbList.vue?vue&type=template&id=0bc9f712&scoped=true"
import script from "./lbList.vue?vue&type=script&lang=js"
export * from "./lbList.vue?vue&type=script&lang=js"
import style0 from "./lbList.vue?vue&type=style&index=0&id=0bc9f712&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc9f712",
  null
  
)

export default component.exports